/**
 * CONSAI Business App - Translations (English/Hindi)
 */

export const translations = {
  // Common
  appName: {
    en: "CONSAI Business",
    hi: "CONSAI बिज़नेस"
  },
  loading: {
    en: "Loading...",
    hi: "लोड हो रहा है..."
  },
  save: {
    en: "Save",
    hi: "सहेजें"
  },
  cancel: {
    en: "Cancel",
    hi: "रद्द करें"
  },
  submit: {
    en: "Submit",
    hi: "जमा करें"
  },
  delete: {
    en: "Delete",
    hi: "हटाएं"
  },
  edit: {
    en: "Edit",
    hi: "संपादित करें"
  },
  close: {
    en: "Close",
    hi: "बंद करें"
  },
  confirm: {
    en: "Confirm",
    hi: "पुष्टि करें"
  },
  yes: {
    en: "Yes",
    hi: "हाँ"
  },
  no: {
    en: "No",
    hi: "नहीं"
  },
  comingSoon: {
    en: "Coming Soon",
    hi: "जल्द आ रहा है"
  },
  comingSoonPhase3: {
    en: "Coming in Phase 3",
    hi: "फेज 3 में आ रहा है"
  },
  paymentComingSoon: {
    en: "Payment integration coming in Phase 2",
    hi: "पेमेंट इंटीग्रेशन फेज 2 में आ रहा है"
  },

  // Auth
  login: {
    en: "Login",
    hi: "लॉगिन"
  },
  signup: {
    en: "Sign Up",
    hi: "साइन अप"
  },
  logout: {
    en: "Logout",
    hi: "लॉगआउट"
  },
  logoutConfirm: {
    en: "Are you sure you want to logout?",
    hi: "क्या आप लॉगआउट करना चाहते हैं?"
  },
  email: {
    en: "Email",
    hi: "ईमेल"
  },
  mobile: {
    en: "Mobile Number",
    hi: "मोबाइल नंबर"
  },
  password: {
    en: "Password",
    hi: "पासवर्ड"
  },
  confirmPassword: {
    en: "Confirm Password",
    hi: "पासवर्ड की पुष्टि करें"
  },
  emailOrMobile: {
    en: "Email or Mobile Number",
    hi: "ईमेल या मोबाइल नंबर"
  },
  rememberMe: {
    en: "Remember me",
    hi: "मुझे याद रखें"
  },
  forgotPassword: {
    en: "Forgot Password?",
    hi: "पासवर्ड भूल गए?"
  },
  resetPassword: {
    en: "Reset Password",
    hi: "पासवर्ड रीसेट करें"
  },
  signInWithGoogle: {
    en: "Sign in with Google",
    hi: "Google से साइन इन करें"
  },
  signUpWithGoogle: {
    en: "Sign up with Google",
    hi: "Google से साइन अप करें"
  },
  noAccount: {
    en: "Don't have an account?",
    hi: "खाता नहीं है?"
  },
  haveAccount: {
    en: "Already have an account?",
    hi: "पहले से खाता है?"
  },
  name: {
    en: "Name",
    hi: "नाम"
  },
  fullName: {
    en: "Full Name",
    hi: "पूरा नाम"
  },
  enterOtp: {
    en: "Enter OTP",
    hi: "OTP दर्ज करें"
  },
  verifyOtp: {
    en: "Verify OTP",
    hi: "OTP सत्यापित करें"
  },
  resendOtp: {
    en: "Resend OTP",
    hi: "OTP दोबारा भेजें"
  },
  otpSent: {
    en: "OTP sent to your mobile",
    hi: "OTP आपके मोबाइल पर भेजा गया"
  },
  
  // Language
  selectLanguage: {
    en: "Select Language",
    hi: "भाषा चुनें"
  },
  english: {
    en: "English",
    hi: "अंग्रेज़ी"
  },
  hindi: {
    en: "Hindi",
    hi: "हिंदी"
  },

  // Navigation
  dashboard: {
    en: "Dashboard",
    hi: "डैशबोर्ड"
  },
  reportAndPlan: {
    en: "Report & Plan",
    hi: "रिपोर्ट और प्लान"
  },
  customers: {
    en: "Customers",
    hi: "ग्राहक"
  },
  stock: {
    en: "Stock",
    hi: "स्टॉक"
  },
  sales: {
    en: "Sales",
    hi: "बिक्री"
  },
  invoices: {
    en: "Invoices",
    hi: "इनवॉइस"
  },
  creditKhatabook: {
    en: "Credit/Khatabook",
    hi: "उधार/खाताबुक"
  },
  profile: {
    en: "Profile",
    hi: "प्रोफाइल"
  },

  // Dashboard
  welcomeBack: {
    en: "Welcome back",
    hi: "वापसी पर स्वागत है"
  },
  totalSalesToday: {
    en: "Total Sales Today",
    hi: "आज की कुल बिक्री"
  },
  pendingPayments: {
    en: "Pending Payments",
    hi: "बकाया भुगतान"
  },
  lowStockItems: {
    en: "Low Stock Items",
    hi: "कम स्टॉक आइटम"
  },
  totalCustomers: {
    en: "Total Customers",
    hi: "कुल ग्राहक"
  },
  startTracking: {
    en: "Start tracking to see data",
    hi: "डेटा देखने के लिए ट्रैकिंग शुरू करें"
  },
  quickActions: {
    en: "Quick Actions",
    hi: "त्वरित कार्य"
  },
  addSale: {
    en: "Add Sale",
    hi: "बिक्री जोड़ें"
  },
  addCustomer: {
    en: "Add Customer",
    hi: "ग्राहक जोड़ें"
  },
  addStock: {
    en: "Add Stock",
    hi: "स्टॉक जोड़ें"
  },
  viewReport: {
    en: "View Report",
    hi: "रिपोर्ट देखें"
  },
  getBusinessReport: {
    en: "Get Your Business Growth Report",
    hi: "अपनी बिज़नेस ग्रोथ रिपोर्ट पाएं"
  },
  reportFeatures: {
    en: "McKinsey-style consulting report • AI-generated growth plan • Premium features FREE for 30 days",
    hi: "McKinsey-स्टाइल कंसल्टिंग रिपोर्ट • AI-जनरेटेड ग्रोथ प्लान • 30 दिन प्रीमियम फीचर्स मुफ्त"
  },
  getReport: {
    en: "Get Report",
    hi: "रिपोर्ट पाएं"
  },
  purchaseToUnlock: {
    en: "Purchase report to unlock",
    hi: "अनलॉक करने के लिए रिपोर्ट खरीदें"
  },

  // Plans
  yourPlan: {
    en: "Your Plan",
    hi: "आपका प्लान"
  },
  currentPlan: {
    en: "Current Plan",
    hi: "वर्तमान प्लान"
  },
  starterPlan: {
    en: "Starter Plan",
    hi: "स्टार्टर प्लान"
  },
  premiumPlan: {
    en: "Premium Plan",
    hi: "प्रीमियम प्लान"
  },
  premiumTrial: {
    en: "Premium Trial",
    hi: "प्रीमियम ट्रायल"
  },
  daysRemaining: {
    en: "days remaining",
    hi: "दिन बाकी"
  },
  upgrade: {
    en: "Upgrade",
    hi: "अपग्रेड करें"
  },
  upgradeToPremium: {
    en: "Upgrade to Premium",
    hi: "प्रीमियम में अपग्रेड करें"
  },
  upgradeToUnlock: {
    en: "Upgrade to unlock",
    hi: "अनलॉक करने के लिए अपग्रेड करें"
  },
  planFeatures: {
    en: "Plan Features",
    hi: "प्लान फीचर्स"
  },
  whatsIncluded: {
    en: "What's included in your plan",
    hi: "आपके प्लान में क्या शामिल है"
  },
  premiumOnly: {
    en: "Premium Only",
    hi: "केवल प्रीमियम"
  },

  // Profile
  editProfile: {
    en: "Edit Profile",
    hi: "प्रोफाइल संपादित करें"
  },
  businessName: {
    en: "Business Name",
    hi: "व्यवसाय का नाम"
  },
  ownerName: {
    en: "Owner Name",
    hi: "मालिक का नाम"
  },
  businessType: {
    en: "Business Type",
    hi: "व्यवसाय का प्रकार"
  },
  businessAddress: {
    en: "Business Address",
    hi: "व्यवसाय का पता"
  },
  gstNumber: {
    en: "GST Number",
    hi: "GST नंबर"
  },
  city: {
    en: "City",
    hi: "शहर"
  },
  state: {
    en: "State",
    hi: "राज्य"
  },
  businessLogo: {
    en: "Business Logo",
    hi: "व्यवसाय लोगो"
  },
  uploadLogo: {
    en: "Upload Logo",
    hi: "लोगो अपलोड करें"
  },
  removeLogo: {
    en: "Remove Logo",
    hi: "लोगो हटाएं"
  },
  changePassword: {
    en: "Change Password",
    hi: "पासवर्ड बदलें"
  },
  currentPassword: {
    en: "Current Password",
    hi: "वर्तमान पासवर्ड"
  },
  newPassword: {
    en: "New Password",
    hi: "नया पासवर्ड"
  },
  subscriptionDetails: {
    en: "Subscription Details",
    hi: "सब्सक्रिप्शन विवरण"
  },
  notificationPreferences: {
    en: "Notification Preferences",
    hi: "नोटिफिकेशन प्राथमिकताएं"
  },
  emailNotifications: {
    en: "Email Notifications",
    hi: "ईमेल नोटिफिकेशन"
  },
  whatsappNotifications: {
    en: "WhatsApp Notifications",
    hi: "WhatsApp नोटिफिकेशन"
  },
  lowStockAlerts: {
    en: "Low Stock Alerts",
    hi: "कम स्टॉक अलर्ट"
  },
  paymentReminders: {
    en: "Payment Reminders",
    hi: "पेमेंट रिमाइंडर"
  },
  dailySummary: {
    en: "Daily Summary",
    hi: "दैनिक सारांश"
  },
  languagePreference: {
    en: "Language Preference",
    hi: "भाषा प्राथमिकता"
  },
  profileUpdated: {
    en: "Profile updated successfully",
    hi: "प्रोफाइल सफलतापूर्वक अपडेट हो गई"
  },
  passwordChanged: {
    en: "Password changed successfully",
    hi: "पासवर्ड सफलतापूर्वक बदल गया"
  },

  // Business Types
  businessTypes: {
    kirana: { en: "Kirana/Grocery Store", hi: "किराना/ग्रोसरी स्टोर" },
    medical: { en: "Medical Store", hi: "मेडिकल स्टोर" },
    bakery: { en: "Bakery", hi: "बेकरी" },
    clothing: { en: "Clothing/Textile Shop", hi: "कपड़ा/टेक्सटाइल दुकान" },
    electronics: { en: "Electronics Shop", hi: "इलेक्ट्रॉनिक्स दुकान" },
    restaurant: { en: "Restaurant/Food Service", hi: "रेस्तरां/फूड सर्विस" },
    hardware: { en: "Hardware Store", hi: "हार्डवेयर स्टोर" },
    stationery: { en: "Stationery Shop", hi: "स्टेशनरी दुकान" },
    mobile: { en: "Mobile/Accessories Shop", hi: "मोबाइल/एक्सेसरीज दुकान" },
    footwear: { en: "Footwear Shop", hi: "फुटवियर दुकान" },
    cosmetics: { en: "Cosmetics/Beauty Shop", hi: "कॉस्मेटिक्स/ब्यूटी दुकान" },
    furniture: { en: "Furniture Shop", hi: "फर्नीचर दुकान" },
    pharmacy: { en: "Pharmacy", hi: "फार्मेसी" },
    automotive: { en: "Automotive Parts", hi: "ऑटोमोटिव पार्ट्स" },
    bookstore: { en: "Book Store", hi: "किताब की दुकान" },
    other: { en: "Other", hi: "अन्य" }
  },

  // Indian States
  states: {
    AN: { en: "Andaman and Nicobar Islands", hi: "अंडमान और निकोबार द्वीप" },
    AP: { en: "Andhra Pradesh", hi: "आंध्र प्रदेश" },
    AR: { en: "Arunachal Pradesh", hi: "अरुणाचल प्रदेश" },
    AS: { en: "Assam", hi: "असम" },
    BR: { en: "Bihar", hi: "बिहार" },
    CH: { en: "Chandigarh", hi: "चंडीगढ़" },
    CT: { en: "Chhattisgarh", hi: "छत्तीसगढ़" },
    DN: { en: "Dadra and Nagar Haveli", hi: "दादरा और नगर हवेली" },
    DD: { en: "Daman and Diu", hi: "दमन और दीव" },
    DL: { en: "Delhi", hi: "दिल्ली" },
    GA: { en: "Goa", hi: "गोआ" },
    GJ: { en: "Gujarat", hi: "गुजरात" },
    HR: { en: "Haryana", hi: "हरियाणा" },
    HP: { en: "Himachal Pradesh", hi: "हिमाचल प्रदेश" },
    JK: { en: "Jammu and Kashmir", hi: "जम्मू और कश्मीर" },
    JH: { en: "Jharkhand", hi: "झारखंड" },
    KA: { en: "Karnataka", hi: "कर्नाटक" },
    KL: { en: "Kerala", hi: "केरल" },
    LA: { en: "Ladakh", hi: "लद्दाख" },
    LD: { en: "Lakshadweep", hi: "लक्षद्वीप" },
    MP: { en: "Madhya Pradesh", hi: "मध्य प्रदेश" },
    MH: { en: "Maharashtra", hi: "महाराष्ट्र" },
    MN: { en: "Manipur", hi: "मणिपुर" },
    ML: { en: "Meghalaya", hi: "मेघालय" },
    MZ: { en: "Mizoram", hi: "मिज़ोरम" },
    NL: { en: "Nagaland", hi: "नागालैंड" },
    OR: { en: "Odisha", hi: "ओडिशा" },
    PY: { en: "Puducherry", hi: "पुडुचेरी" },
    PB: { en: "Punjab", hi: "पंजाब" },
    RJ: { en: "Rajasthan", hi: "राजस्थान" },
    SK: { en: "Sikkim", hi: "सिक्किम" },
    TN: { en: "Tamil Nadu", hi: "तमिलनाडु" },
    TG: { en: "Telangana", hi: "तेलंगाना" },
    TR: { en: "Tripura", hi: "त्रिपुरा" },
    UP: { en: "Uttar Pradesh", hi: "उत्तर प्रदेश" },
    UK: { en: "Uttarakhand", hi: "उत्तराखंड" },
    WB: { en: "West Bengal", hi: "पश्चिम बंगाल" }
  },

  // Admin
  adminPanel: {
    en: "Admin Panel",
    hi: "एडमिन पैनल"
  },
  adminLogin: {
    en: "Admin Login",
    hi: "एडमिन लॉगिन"
  },
  clients: {
    en: "Clients",
    hi: "क्लाइंट्स"
  },
  reports: {
    en: "Reports",
    hi: "रिपोर्ट्स"
  },
  payments: {
    en: "Payments",
    hi: "भुगतान"
  },
  vouchers: {
    en: "Vouchers",
    hi: "वाउचर"
  },
  analytics: {
    en: "Analytics",
    hi: "एनालिटिक्स"
  },
  settings: {
    en: "Settings",
    hi: "सेटिंग्स"
  },
  totalClients: {
    en: "Total Clients",
    hi: "कुल क्लाइंट्स"
  },
  activeUsers: {
    en: "Active Users",
    hi: "एक्टिव यूज़र्स"
  },
  last7Days: {
    en: "Last 7 days",
    hi: "पिछले 7 दिन"
  },
  reportsGenerated: {
    en: "Reports Generated",
    hi: "जनरेटेड रिपोर्ट्स"
  },
  totalRevenue: {
    en: "Total Revenue",
    hi: "कुल राजस्व"
  },
  search: {
    en: "Search",
    hi: "खोजें"
  },
  searchClients: {
    en: "Search by name, email, mobile, or client ID",
    hi: "नाम, ईमेल, मोबाइल या क्लाइंट ID से खोजें"
  },
  allPlans: {
    en: "All Plans",
    hi: "सभी प्लान"
  },
  allStatus: {
    en: "All Status",
    hi: "सभी स्टेटस"
  },
  active: {
    en: "Active",
    hi: "सक्रिय"
  },
  inactive: {
    en: "Inactive",
    hi: "निष्क्रिय"
  },
  viewDetails: {
    en: "View Details",
    hi: "विवरण देखें"
  },
  clientDetails: {
    en: "Client Details",
    hi: "क्लाइंट विवरण"
  },
  clientId: {
    en: "Client ID",
    hi: "क्लाइंट ID"
  },
  signupDate: {
    en: "Signup Date",
    hi: "साइनअप तिथि"
  },
  lastLogin: {
    en: "Last Login",
    hi: "अंतिम लॉगिन"
  },
  changePlan: {
    en: "Change Plan",
    hi: "प्लान बदलें"
  },
  extendTrial: {
    en: "Extend Trial",
    hi: "ट्रायल बढ़ाएं"
  },
  deactivateAccount: {
    en: "Deactivate Account",
    hi: "खाता निष्क्रिय करें"
  },
  activateAccount: {
    en: "Activate Account",
    hi: "खाता सक्रिय करें"
  },
  deleteAccount: {
    en: "Delete Account",
    hi: "खाता हटाएं"
  },
  deleteConfirm: {
    en: "This will permanently delete all data. Are you sure?",
    hi: "यह सभी डेटा स्थायी रूप से हटा देगा। क्या आप निश्चित हैं?"
  },
  sendResetLink: {
    en: "Send Password Reset Link",
    hi: "पासवर्ड रीसेट लिंक भेजें"
  },
  reportPurchased: {
    en: "Report Purchased",
    hi: "रिपोर्ट खरीदी गई"
  },

  // Errors
  invalidEmail: {
    en: "Invalid email format",
    hi: "अमान्य ईमेल प्रारूप"
  },
  invalidMobile: {
    en: "Invalid mobile number",
    hi: "अमान्य मोबाइल नंबर"
  },
  passwordTooShort: {
    en: "Password must be at least 8 characters",
    hi: "पासवर्ड कम से कम 8 अक्षर का होना चाहिए"
  },
  passwordsMismatch: {
    en: "Passwords do not match",
    hi: "पासवर्ड मेल नहीं खाते"
  },
  loginFailed: {
    en: "Login failed. Please check your credentials.",
    hi: "लॉगिन विफल। कृपया अपने क्रेडेंशियल जांचें।"
  },
  sessionExpired: {
    en: "Session expired. Please login again.",
    hi: "सत्र समाप्त। कृपया दोबारा लॉगिन करें।"
  },
  somethingWentWrong: {
    en: "Something went wrong. Please try again.",
    hi: "कुछ गलत हो गया। कृपया पुनः प्रयास करें।"
  },

  // Success messages
  loginSuccess: {
    en: "Login successful!",
    hi: "लॉगिन सफल!"
  },
  signupSuccess: {
    en: "Account created successfully!",
    hi: "खाता सफलतापूर्वक बनाया गया!"
  },
  otpVerified: {
    en: "OTP verified successfully!",
    hi: "OTP सफलतापूर्वक सत्यापित!"
  },

  // Help & Support
  help: {
    en: "Help",
    hi: "मदद"
  },
  support: {
    en: "Support",
    hi: "सहायता"
  },
  feedback: {
    en: "Feedback",
    hi: "प्रतिक्रिया"
  },
  version: {
    en: "Version",
    hi: "संस्करण"
  }
};

/**
 * Get translated text
 * @param {string} key - Translation key
 * @param {string} lang - Language code ('en' or 'hi')
 * @returns {string} Translated text
 */
export const t = (key, lang = 'en') => {
  const keys = key.split('.');
  let result = translations;
  
  for (const k of keys) {
    if (result && result[k]) {
      result = result[k];
    } else {
      return key; // Return key if translation not found
    }
  }
  
  if (typeof result === 'object' && result[lang]) {
    return result[lang];
  }
  
  return key;
};

export default translations;
